import { useLocation, useNavigate, useParams } from 'react-router-dom';

import CoursePath from '@/models/CoursePath';
import Klass from '@/models/Klass';
import { Nullable } from '@/models/Model';
import { ROUTES } from '@/utils/routes';

type StaffCourseSelectionState = Nullable<{ isCleared?: boolean }>;

export default function useStaffCourseSelection() {
  const { slugCourseName, klassId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const isCleared = !!(state as StaffCourseSelectionState)?.isCleared;

  const selectCourse = (coursePath: Nullable<CoursePath>) =>
    coursePath
      ? navigate(ROUTES.COURSES.INFO(coursePath.slug))
      : navigate(ROUTES.COURSES.BASE, { state: { isCleared: true } });

  const selectKlass = (klass: Nullable<Klass>) =>
    navigate(
      klass
        ? ROUTES.COURSES.INFO(klass.coursePathSlug, klass.id)
        : ROUTES.COURSES.INFO(slugCourseName ?? ''),
    );

  return {
    slug: slugCourseName,
    klassId,
    shouldSelectDefaultKlass: !slugCourseName && !isCleared,
    selectCourse,
    selectKlass,
  };
}
